<template>
    <vue-final-modal v-model="visible">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header border-bottom-0">
                    <h5 class="modal-title">
                        Just a few more details so professionals can contact you...
                    </h5>
                    <button type="button" class="btn-close" aria-label="Close" @click="closeModal"></button>
                </div>
                <div class="modal-body">

                    <!-- Tabs -->
                    <ul class="nav nav-tabs mb-4" id="accountTabs" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" :class="{ active: tab === 'create-account' }" 
                                    id="create-account-tab" type="button" role="tab" 
                                    @click="switchTab('create-account')"
                                    aria-controls="create-account" :aria-selected="tab === 'create-account'">New Account</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" :class="{ active: tab === 'login' }" 
                                    id="login-tab" type="button" role="tab" 
                                    @click="switchTab('login')"
                                    aria-controls="login" :aria-selected="tab === 'login'">Login</button>
                        </li>
                    </ul>

                    <!-- Tab Content -->
                    <div class="tab-content" id="accountTabsContent">
                        <!-- Create Account Tab -->
                        <div class="tab-pane" :class="{ 'fade show active': tab === 'create-account' }" 
                             id="create-account" role="tabpanel" 
                             aria-labelledby="create-account-tab" v-show="tab === 'create-account'">

                        <div class="row">
                            <div class="col-md-6">
                                <div class="mb-4">
                                    <label class="form-label" for="name">Your Name <span
                                            class="text-danger">*</span></label>
                                    <input v-model="form.name" class="form-control form-control-lg" type="text" id="name"
                                        :disabled="isSaving" placeholder="Enter your name" required>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="mb-4">
                                    <label class="form-label" for="email">Your Email <span
                                            class="text-danger">*</span></label>
                                    <input v-model="form.email" class="form-control form-control-lg" type="text" id="email"
                                        :disabled="isSaving" placeholder="Enter your email" required>
                                </div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-md-6">
                                <div class="mb-4">
                                    <label class="form-label" for="phone">Phone Number<span
                                            class="text-danger">*</span></label>
                                    <input v-model="form.phone" class="form-control form-control-lg" type="tel"
                                        id="phone" :disabled="isSaving" placeholder="Enter your mobile number" required>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mb-4">
                                    <label class="form-label" for="password">Password <span
                                            class="text-danger">*</span></label>
                                    <input v-model="form.password" class="form-control form-control-lg" type="password"
                                        id="password" :disabled="isSaving" placeholder="Enter a password" required>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="mb-4">
                                    <label class="form-label" for="companyName">Company Name (If Applicable)</label>
                                    <input v-model="form.company_name" class="form-control form-control-lg" type="text"
                                        id="companyName" :disabled="isSaving" placeholder="Enter your company name">
                                </div>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-md-12">
                                <div class="mb-4">
                                    <div class="">
                                        <!-- <input v-model="form.agree_to_terms" class="form-check-input" type="checkbox" id="agreeToTerms" :disabled="isSaving" required>
                                        <label class="form-check-label" for="agreeToTerms">
                                            I agree to the <a href="https://cdn.prod.website-files.com/64943ca2ceb618f0fa485f81/682df97de4a6e87953bf3559__Syndesi%20Platform%20Terms%20-%2021_5_25.pdf" target="_blank">Terms of Service</a> and <a href="https://cdn.prod.website-files.com/64943ca2ceb618f0fa485f81/67698cccb85d917b09a00bec_Syndesi%20Privacy%20Notice%20(1).pdf" target="_blank">Privacy Policy</a>
                                        </label> -->
                                        <label>
                                                By signing up, you agree to Syndesi's <a href="https://cdn.prod.website-files.com/64943ca2ceb618f0fa485f81/682df97de4a6e87953bf3559__Syndesi%20Platform%20Terms%20-%2021_5_25.pdf" target="_blank">Terms of Service</a> and <a href="https://cdn.prod.website-files.com/64943ca2ceb618f0fa485f81/68760cbc4c58f63d40c37040_Syndesi%20Privacy%20Notice%20(15_07_25).docx.pdf" target="_blank">Privacy Policy</a>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="mb-4">
                                    <div class="form-check">
                                        <input v-model="form.marketing_consent" class="form-check-input" type="checkbox" id="marketingConsent" :disabled="isSaving">
                                        <label class="form-check-label" for="marketingConsent">
                                            I agree to receive updates and marketing communications from Syndesi 
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-2 pt-2">
                            <button class="btn btn-primary btn-lg rounded-pill w-100" :disabled="isSaving"
                                @click="handleCreateAccountButton">
                                <spinner v-if="isSaving" class="spinner-border-sm me-2"></spinner>
                                <i v-else class="fi-lock fs-sm me-2"></i>
                                <span>{{ isSaving ? 'Creating' : 'Create' }}</span> Account
                            </button>
                        </div>

                        <!-- <div class="mt-4 mb-4">
                            <i>Alternatively...</i>
                        </div>

                        <div class="mb-2">
                            <button class="btn btn-dark btn-lg rounded-pill" style="background-color: rgb(10, 102, 194)"
                                :disabled="isSaving">
                                <spinner v-if="isSaving" class="spinner-border-sm me-2"></spinner>
                                <i v-else class="fi-linkedin fs-sm me-2"></i>
                                Sign Up With LinkedIn
                            </button>
                        </div> -->

                        </div>
                        <!-- / Create Account Tab -->

                        <!-- Login Tab -->
                        <div class="tab-pane" :class="{ 'fade show active': tab === 'login' }" 
                             id="login" role="tabpanel" 
                             aria-labelledby="login-tab" v-show="tab === 'login'">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="mb-4">
                                        <label class="form-label" for="loginEmail">Email <span
                                                class="text-danger">*</span></label>
                                        <input v-model="loginForm.email" class="form-control form-control-lg"
                                            type="email" id="loginEmail" :disabled="isSaving" 
                                            placeholder="Enter your email" required>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="mb-4">
                                        <label class="form-label" for="loginPassword">Password <span
                                                class="text-danger">*</span></label>
                                        <input v-model="loginForm.password" class="form-control form-control-lg"
                                            type="password" id="loginPassword" :disabled="isSaving"
                                            placeholder="Enter your password" required>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="text-end">
                                        <a href="/forgot-password" target="_blank" class="text-decoration-none text-muted fs-sm">
                                            Forgot your password?
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-2 pt-4">
                                <button class="btn btn-primary btn-lg rounded-pill w-100" :disabled="isSaving"
                                    @click="handleLoginButton">
                                    <spinner v-if="isSaving" class="spinner-border-sm me-2"></spinner>
                                    <i v-else class="fi-lock fs-sm me-2"></i>
                                    <span>{{ isSaving ? 'Logging In...' : 'Login' }}</span>
                                </button>
                            </div>
                        </div>
                        <!-- / Login Tab -->
                    </div>
                    <!-- / Tab Content -->

                </div>
            </div>
        </div>
    </vue-final-modal>

    <!-- Loading Overlay -->
    <div v-if="showLoadingOverlay" class="loading-overlay">
        <div class="loading-content">
            <spinner class="mb-3"></spinner>
            <h5>{{ loadingMessage }}</h5>
            <p class="text-muted">Please wait while we prepare everything for you.</p>
        </div>
    </div>
    <!-- / Loading Overlay -->
</template>
  
<script>
import Spinner from "../../../../../components/Spinner.vue";
import axios from 'axios';
import Forms from "../../../../../mixins/Forms";
import { mapGetters, mapActions } from 'vuex';

export default {
    name: "LoginAndSignupModal",
    mixins: [Forms],
    components: { Spinner },
    data() {
        return {
            visible: false,
            isSaving: false,
            serverErrors: [],
            form: {
                name: '',
                email: '',
                phone: '',
                password: '',
                password_confirmation: '',
                company_name: '',
                agree_to_terms: true,
                marketing_consent: false
            },
            loginForm: {
                email: '',
                password: ''
            },
            tab: 'create-account', // create-account or login
            showLoadingOverlay: false,
            currentJobId: null
        }
    },
    computed: {
        ...mapGetters('whitelabelConfiguration', {
            whitelabelConfigurationId: 'whitelabelConfigurationId'
        }),

        loadingMessage() {
            // If we're in the saving process (registration/login), show appropriate message
            if (this.isSaving && this.showLoadingOverlay) {
                if (this.tab === 'create-account') {
                    return 'Creating your account...';
                } else {
                    return 'Logging you in...';
                }
            }
            
            const jobsLoaded = !this.$store.getters['jobs/isLoading'];
            const userRoleAvailable = this.$store.getters['auth/userRole'] !== null;
            const websocketListenerSetUp = this.$store.getters['websocketListener/listeningToUserRoleId'] !== null;
            
            // Check if the new job is in the jobs list (if we have a jobId to check)
            const jobs = this.$store.getters['jobs/jobs'];
            const newJobExists = jobs.some(job => job.id == this.currentJobId);
            
            if (!jobsLoaded) {
                return 'Loading your jobs...';
            } else if (!userRoleAvailable) {
                return 'Setting up your account...';
            } else if (!websocketListenerSetUp) {
                return 'Connecting to real-time updates...';
            } else if (jobsLoaded && !newJobExists && this.currentJobId) {
                return 'Refreshing job list...';
            } else {
                return 'Setting up your conversation...';
            }
        }
    },
    methods: {
        ...mapActions('auth', {
            handleUserRegistered: 'handleUserRegistered',
            attemptLoginInline: 'attemptLoginInline',
            loadAndSelectFirstClientUserRoleInline: 'loadAndSelectFirstClientUserRoleInline'
        }),

        openModal() {
            this.visible = true;
        },

        closeModal() {
            this.visible = false;
        },

        switchTab(tabName) {
            this.tab = tabName;
        },

        handleCreateAccountButton() {
            let vm = this;
            vm.isSaving = true;
            vm.showLoadingOverlay = true; // Show loading overlay immediately
            
            axios.post(window.API_BASE + '/client-register', {
                name: vm.form.name,
                email: vm.form.email,
                password: vm.form.password,
                // password_confirmation: vm.form.password_confirmation,
                password_confirmation: vm.form.password,
                phone: vm.form.phone,
                company_name: vm.form.company_name,
                wcid: vm.whitelabelConfigurationId,
                agree_to_terms: vm.form.agree_to_terms,
                marketing_consent: vm.form.marketing_consent
            }).then(r => {
                vm.handleUserRegistered(r.data).then(r => {
                    vm.isSaving = false;
                    // Wait for jobs to load and websockets to connect before redirecting
                    vm.waitForJobsAndWebsockets();
                }).catch(e => {
                    console.log(e);
                    vm.isSaving = false;
                    vm.showLoadingOverlay = false; // Hide overlay on error
                    vm.setAndNotifyErrors(e);
                });
            }).catch(e => {
                console.log(e);
                vm.isSaving = false;
                vm.showLoadingOverlay = false; // Hide overlay on error
                vm.setAndNotifyErrors(e);
            });
        },

        handleLoginButton() {
            let vm = this;
            vm.isSaving = true;
            vm.serverErrors = [];
            vm.showLoadingOverlay = true; // Show loading overlay immediately

            vm.attemptLoginInline({
                email: vm.loginForm.email,
                password: vm.loginForm.password
            }).then(() => {
                vm.loadAndSelectFirstClientUserRoleInline().then(rr => {
                    vm.isSaving = false;
                    // Wait for jobs to load and websockets to connect before redirecting
                    vm.waitForJobsAndWebsockets();
                }).catch(ee => {
                    console.log(ee);
                    vm.isSaving = false;
                    vm.showLoadingOverlay = false; // Hide overlay on error
                    vm.setAndNotifyErrors(ee);
                })
            }).catch(e => {
                console.log(e);
                vm.isSaving = false;
                vm.showLoadingOverlay = false; // Hide overlay on error
                vm.setAndNotifyErrors(e);
            });
        },

        waitForJobsAndWebsockets() {
            // Close the modal
            this.visible = false;
            
            // Show loading overlay
            this.showLoadingOverlay = true;
            
            // Force reload jobs to ensure they're up to date
            this.$store.dispatch('jobs/loadJobs');
            
            let checkInterval = setInterval(() => {
                // Check if jobs are loaded
                const jobsLoaded = !this.$store.getters['jobs/isLoading'];
                
                // Check if user role is available
                const userRoleAvailable = this.$store.getters['auth/userRole'] !== null;
                
                // Check if websockets are connected - handle different connection states
                let websocketsConnected = false;
                if (window.Echo && window.Echo.connector && window.Echo.connector.pusher) {
                    const connectionState = window.Echo.connector.pusher.connection.state;
                    websocketsConnected = connectionState === 'connected' || connectionState === 'connecting';
                }
                
                // Check if websocket listener is set up
                const websocketListenerSetUp = this.$store.getters['websocketListener/listeningToUserRoleId'] !== null;
                
                if (jobsLoaded && websocketsConnected && userRoleAvailable && websocketListenerSetUp) {
                    clearInterval(checkInterval);
                    this.showLoadingOverlay = false;
                    this.isSaving = false; // Set isSaving to false only when everything is complete
                    
                    // Emit registered event after everything is ready
                    this.$emit('registered');
                }
            }, 200);
            
            // Timeout after 10 seconds to prevent infinite waiting
            setTimeout(() => {
                clearInterval(checkInterval);
                this.showLoadingOverlay = false;
                this.isSaving = false; // Set isSaving to false on timeout as well
                this.$emit('registered');
            }, 10000);
        }
    }
}
</script>
  
<style scoped lang="scss">
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(6px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.loading-content {
    background-color: white;
    padding: 2rem;
    border-radius: 8px;
    text-align: center;
    max-width: 400px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>